import { render, staticRenderFns } from "./AssignConfigModal.vue?vue&type=template&id=38bf47d2&scoped=true"
import script from "./AssignConfigModal.vue?vue&type=script&lang=js"
export * from "./AssignConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bf47d2",
  null
  
)

export default component.exports